import React from "react";
import { Link } from "react-router-dom";
import styles from "./FaqsSection.module.css";
import usePublishedFaqs from "../../hooks/usePublishedFaqs";

const FaqsSection = () => {
  const { items, loading } = usePublishedFaqs();
  const flatItems = items.flatMap((faq) =>
    Array.isArray(faq.faqItems)
      ? faq.faqItems.map((item, index) => ({
          id: `${faq.slug}-${index}`,
          title: item.title,
          contentHtml: item.contentHtml || "",
        }))
      : [],
  );

  return (
    <section className={`section ${styles.section}`}>
      <div className="container-lg">
        <div className={styles.frame}>
          <div className={styles.header}>
            <div>
              <span className={styles.eyebrow}>Preguntas frecuentes</span>
              <h2>Resolvé tus dudas antes de contratar tu alarma ADT</h2>
              <p>
                Todo lo que necesitás saber sobre los sistemas de seguridad ADT en Argentina, desde cómo funciona el monitoreo hasta los packs disponibles para tu hogar o comercio.
              </p>
            </div>
          </div>

          {loading ? <p className={styles.loading}>Cargando FAQs publicadas...</p> : null}

          <div className={styles.list}>
            {flatItems.map((item) => (
              <details className={styles.item} key={item.id}>
                <summary className={styles.summary}>
                  <div>
                    <h3>{item.title}</h3>
                  </div>
                  <span className={styles.icon} aria-hidden="true" />
                </summary>

                <div className={styles.content}>
                  <div
                    className={styles.richtext}
                    dangerouslySetInnerHTML={{ __html: item.contentHtml }}
                  />
                </div>
              </details>
            ))}

            {!loading && flatItems.length === 0 ? (
              <p className={styles.empty}>Todavía no hay preguntas frecuentes publicadas.</p>
            ) : null}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FaqsSection;
